import React from 'react';

import './steps.scss';
import AutoWrapper from './auto-wrapper';

const AutoLine = (props: any) => <AutoWrapper {...props} />;

export default AutoLine;
